<p-toast position="bottom-right"></p-toast>

<div>
    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="openRelaciones()">
            <mat-icon>link</mat-icon>
            Relaciones
        </button>
    </div>

    <p-table #dt [value]="dataSource" [columns]="displayedColumns" [paginator]="true" [rows]="rows" [first]="first"
        [totalRecords]="totalRecords" [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 20]"
        [scrollable]="true" [scrollHeight]="'calc(100vh - 400px)'" styleClass="p-datatable-gridlines"
        [resizableColumns]="true" [autoLayout]="true" responsiveLayout="scroll" [loading]="loading"
        [globalFilterFields]="['relacion','secuencia','descripcion','tipo']" (onPage)="onPage($event)"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">

        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.field !== 'actions' ? col.field : null"
                    class="th-prime">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td *ngFor="let col of displayedColumns" class="td-prime">
                    <ng-container [ngSwitch]="col.field">
                        <ng-container *ngSwitchCase="'actions'">
                            <div class="d-flex gap-2 justify-content-center">
                                <button pButton icon="pi pi-trash"
                                    class="p-button-rounded p-button-danger p-button-text" (click)="openDelete(rowData)"
                                    pTooltip="Eliminar"></button>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center td-prime">
                    <span *ngIf="dataSource.length === 0 && !loading">No hay datos para mostrar</span>
                    <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8"
                        fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Dialog de Relaciones -->
<p-dialog header="Relaciones Financieras" [(visible)]="displayRelacionesDialog" [modal]="true"
    [style]="{width: '90vw', height: '80vh'}" [draggable]="false" [resizable]="false"
    (onHide)="onRelacionesDialogClosed()">

    <div>
        <div class="search-section">
            <div class="button-section">
                <span class="p-input-icon-left search-input">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="tableRelaciones?.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="Buscar..." class="p-inputtext-sm">
                </span>
            </div>
        </div>

        <p-table #dtRelaciones [value]="relacionesDataSource" [columns]="relacionesDisplayedColumns" [paginator]="true"
            [rows]="relacionesRows" [first]="relacionesFirst" [totalRecords]="relacionesTotalRecords"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 20]" [scrollable]="true"
            [scrollHeight]="'400px'" styleClass="p-datatable-gridlines" [resizableColumns]="true" [autoLayout]="true"
            responsiveLayout="scroll" [loading]="relacionesLoading"
            [globalFilterFields]="['numero_relacion','tipo','descripcion']" (onPage)="onRelacionesPage($event)"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">

            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of relacionesDisplayedColumns" [pSortableColumn]="col.field" class="th-prime">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td *ngFor="let col of relacionesDisplayedColumns" class="td-prime">
                        <ng-container [ngSwitch]="col.field">
                            <ng-container *ngSwitchCase="'numero_relacion'">
                                <a href="javascript:void(0)" (click)="openSecuenciaDialog(rowData)" class="link-primary"
                                    style="color: #007bff; text-decoration: underline; cursor: pointer;">
                                    {{ rowData[col.field] }}
                                </a>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{ rowData[col.field] }}
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3" class="text-center td-prime">
                        <span *ngIf="relacionesDataSource.length === 0 && !relacionesLoading">No hay datos para
                            mostrar</span>
                        <p-progressSpinner *ngIf="relacionesLoading" styleClass="w-4rem h-4rem" strokeWidth="8"
                            fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-dialog>

<!-- Mini Dialog de Secuencia -->
<p-dialog header="Agregar Secuencia" [(visible)]="displaySecuenciaDialog" [modal]="true" [style]="{width: '400px'}"
    [draggable]="false" [resizable]="false" (onHide)="onSecuenciaDialogClosed()">

    <form [formGroup]="secuenciaForm" (ngSubmit)="saveSecuencia()">
        <div class="form-row">
            <div class="form-field">
                <input pInputText type="number" formControlName="secuencia" class="form-control"
                    [placeholder]="'Ingrese la secuencia'" min="0">
                <label>Secuencia</label>
            </div>
        </div>

        <div class="button-section mt-3">
            <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!secuenciaForm.valid">
                <mat-icon>check</mat-icon>
                Aceptar
            </button>
        </div>
    </form>
</p-dialog>